// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3bzZ2","star":"styles_star__aSXee","description":"styles_description__YPZ87"};